import { usePaginatedResource, useResourceItem } from './useCrudResource'
import { getActivityLog, getActivityLogs } from '../api/activityLogApi'

export const ACTIVITY_LOG_QUERY_KEY = 'activity-logs'

export const useActivityLogs = (params = {}, enabled = true) =>
  usePaginatedResource(ACTIVITY_LOG_QUERY_KEY, getActivityLogs, params, enabled)

export const useActivityLog = (id, enabled = true) =>
  useResourceItem(ACTIVITY_LOG_QUERY_KEY, getActivityLog, enabled ? id : null)
